import "./portfolioList.scss"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ButtonSelect from "../buttonSelect/ButtonSelect";

export default function PortfolioList({title, active, icon=null, setSelected, id}){
    return (
        <li className={"portfolioList"} onClick={()=>setSelected(id)}>
            <ButtonSelect icon={icon != null ? <FontAwesomeIcon icon={icon} className={"icon"}/> : ""} title={title} isSelected={active}/>
        </li>
    )
}